import { defineComponent, createElementBlock, openBlock, createVNode, withCtx, renderSlot } from 'vue';
import _sfc_main$1 from './basler-components.es218.js';
/* empty css                        */

const _hoisted_1 = { class: "tabs-text-media-block" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TabsTextMediaBlock",
  props: {
    title: {},
    state: {}
  },
  emits: ["tab-change"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_sfc_main$1, {
          title: _ctx.title,
          "tab-list-position": "bottom",
          state: _ctx.state,
          onTabChange: _cache[0] || (_cache[0] = ($event) => emit("tab-change", $event))
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["title", "state"])
      ]);
    };
  }
});

export { _sfc_main as default };
